export class WatchWorn {
  am: number[] = [];
  pm: number[] = [];

  constructor(length = 12, initialValue = 0) {
    this.am = Array(length).fill(initialValue);
    this.pm = Array(length).fill(initialValue);
  }
}

export class WatchCharging {
  am: WatchChargingItem[] = [];
  pm: WatchChargingItem[] = [];

  constructor(length = 12) {
    const createArray = () => Array.from({ length }, () => ({ value: 0, active: false }));
    this.am = createArray();
    this.pm = createArray();
  }
}

class WatchChargingItem {
  value = 0;
  active = false;
}

export class BiometricCollectionCount {
  am: number[] = [];
  pm: number[] = [];

  constructor(length = 12, initialValue = 0) {
    this.am = Array(length).fill(initialValue);
    this.pm = Array(length).fill(initialValue);
  }
}

export class Imei {
  value = "";
  text = "";
}

export class WatchAssignment {
  clientId = 0;
  participantId = 0;
  imeiId = "";
  changedByUserId?: number;
  assign = false;
}